import { render, staticRenderFns } from "./NewManagementCompany.vue?vue&type=template&id=12e9e65b&scoped=true"
import script from "./NewManagementCompany.vue?vue&type=script&lang=js"
export * from "./NewManagementCompany.vue?vue&type=script&lang=js"
import style0 from "./NewManagementCompany.vue?vue&type=style&index=0&id=12e9e65b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9e65b",
  null
  
)

export default component.exports